import { addressKeys } from '../../../types/index.js';
import { RetailerPartnerType } from '../enum/index.js';
import { retailerLocationKeys } from '../interfaces/index.js'; // not a type interface
export const locations = {
    [RetailerPartnerType.KROGER]: {
        [retailerLocationKeys.id]: 'locationId'
    },
    [RetailerPartnerType.INSTACART]: {},
    [RetailerPartnerType.TARGET]: {
        [retailerLocationKeys.id]: 'locationId'
    },
    [RetailerPartnerType.WALMART]: {
        [retailerLocationKeys.id]: 'fulfillmentStoreId',
        [retailerLocationKeys.address]: 'location'
    }
};
export const addresses = {
    [RetailerPartnerType.KROGER]: {
        [addressKeys.street]: 'line1'
    },
    [RetailerPartnerType.INSTACART]: {},
    [RetailerPartnerType.TARGET]: {
        [addressKeys.street]: 'line'
    },
    [RetailerPartnerType.WALMART]: {
        [addressKeys.street]: 'address'
    }
};
